<template>
    <b-card border-variant="light" :title="label">
        <b-overlay
            variant="white"
            :show="showLoading"
            spinner-variant="primary"
            blur="0"
            opacity=".85"
            rounded="sm"
        >
            <validation-observer ref="namePhone">
                <b-row>
                    <b-col md="4" lg="4">
                        <b-form-group
                            :label="$t('Page(ReceivedRequest):Component(Label):name')"
                            label-for="mc-first-name"
                        >
                            <validation-provider
                                #default="{ errors }"
                                :name="$t('Page(ReceivedRequest):Component(Label):name')"
                                rules="required"
                            >
                                <b-form-input
                                    :state="errors.length > 0 ? false:null"
                                    id="mc-first-name"
                                    :placeholder="$t('Page(ReceivedRequest):Component(Placeholder):name')"
                                    v-model="name"
                                />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                    <b-col md="4" lg="4">
                        <b-form-group
                            v-if="isPhoneMethod"
                            :label="$t('Component(Label):phone')"
                            label-for="phone"
                            class="phone-label"
                        >
                            <VuePhoneNumberInput
                                id="phone"
                                v-model="phone"
                                :translations="phoneNumberTranslations"
                                color="#ff9f43"
                                dark-color="#303144"
                                no-validator-state
                                required
                                :default-country-code="defaultCountryCode"
                                :error="isPhoneInValid"
                                @update="onPhoneSet"
                            />
                        </b-form-group>
                        <b-form-group
                            v-else-if="isEmailMethod"
                            :label="$t('Component(Label):email')"
                            label-for="email"
                            class="phone-label"
                        >
                            <validation-provider
                                #default="{ errors }"
                                :name="$t('Component(Label):email')"
                                rules="required|email"
                            >
                                <b-form-input
                                    :state="errors.length > 0 ? false:null"
                                    id="email"
                                    :placeholder="$t('Component(Placeholder):email')"
                                    v-model="email"
                                />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                    <b-col md="4" lg="4" class="align-items-center d-flex">
                        <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="primary"
                            :disabled="isSendCodeButtonDisabled"
                            @click="send"
                        >
                            {{ $t(isSendCodeSent ? 'Component(Button):resend-code' : 'Component(Button):send-code') }}
                            <span class="ml-1" v-if="isSendCodeButtonDisabled && resendTimer > 0">({{ resendTimer }})</span>
                        </b-button>

                    </b-col>
                </b-row>
            </validation-observer>
            <Transition name="fade">
                <validation-observer ref="code">
                    <b-row v-if="showConfirmationBlock">
                        <b-col md="4" offset="4">
                            <b-form-group
                                :label="$t('Component(Label):code')"
                                label-for="code"
                            >
                                <validation-provider
                                    #default="{ errors }"
                                    :name="$t('Component(Label):code')"
                                    rules="required"
                                >
                                    <b-input-group>
                                        <b-form-input
                                            :state="errors.length > 0 ? false:null"
                                            id="code"
                                            :placeholder="$t('Component(Placeholder):code')"
                                            v-model="code"
                                        />
                                        <b-input-group-append>
                                            <b-button
                                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                                variant="primary"
                                                @click="verify"
                                            >
                                                {{ $t('Component(Button):verify') }}
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                    <small class="text-danger">{{ errorMessage }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </validation-observer>
            </Transition>
        </b-overlay>
    </b-card>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { BCard, BCol, BRow, BFormGroup, BOverlay, BInputGroupAppend,
    BButton, BFormInput, BInputGroupPrepend, BInputGroup } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {ProductApi} from "@core/api";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {required, email} from '@validations'
import {DeclarationApprovalMethod} from "@core/domain/product/received-request";

export default {
    directives: {Ripple},
    components: {
        BCard, BButton, BOverlay, BFormGroup, BFormInput, BInputGroupAppend,
        BCol, BRow, BInputGroupPrepend, BInputGroup, VuePhoneNumberInput, ValidationProvider, ValidationObserver,
    },
    props: {
        requestId: {
            required: true,
        },
        label: {
            type: String,
            default() {
                return 'Approve declaration and send reply to customer';
            }
        },
        method: {
            type: String,
            default: DeclarationApprovalMethod.EMAIL,
        }
    },
    data() {
        return {
            name: '',
            phone: null,
            email: null,
            showLoading: false,
            showConfirmationBlock: false,

            isSendCodeButtonDisabled: false,
            isSendCodeSent: false,
            resendTimerTimeout: 60,
            resendTimer: 60,

            code: null,
            phoneData: null,
            isPhoneInValid: false,
            errorMessage: null,
            required,
            emailConstraint: email
        };
    },
    methods: {
        getCode() {
            let i = 0;
            let code = '';
            while (i < 4) {
                code += Math.floor(Math.random() * 10);
                i++;
            }

            return code;
        },
        send() {
            this.$refs.namePhone.validate().then(isValid => {
                if (this.isPhoneMethod && null === this.phoneData) {
                    this.isPhoneInValid = true;
                    return;
                }

                if (isValid && ((!this.isPhoneInValid && this.isPhoneMethod) || this.isEmailMethod)) {
                    this.showLoading = true;
                    ProductApi
                        .sendApproveDeclarationMessage(
                            this.method,
                            this.requestId,
                            this.name,
                            this.isPhoneMethod ? this.phoneData.formatInternational : this.email)
                        .then((r) => {
                            this.showConfirmationBlock = true;
                            this.isSendCodeSent = true;
                            this.isSendCodeButtonDisabled = true;
                            this.resendTimer = this.resendTimerTimeout;
                            this.startResendTimer();
                        })
                        .finally(() => this.showLoading = false)
                    ;
                }
            });
        },
        verify() {
            this.errorMessage = null;
            this.$refs.code.validate().then(isValid => {
                if (isValid) {
                    this.showLoading = true;
                    ProductApi
                        .approveDeclaration(this.requestId, this.code)
                        .then(() => this.$emit('confirmed'))
                        .catch(e => {
                            if (e.response) {
                                switch (e.response.status) {
                                    case 422:
                                    case 404:
                                        this.errorMessage = e.response.data.detail;
                                        break;

                                    default:
                                        this.errorMessage = e.message;
                                }
                            }
                        })
                        .finally(() => this.showLoading = false)
                }
            });
        },
        onPhoneSet(phone) {
            this.phoneData = phone;
            this.isPhoneInValid = !phone.isValid;
        },
        startResendTimer() {
            if (this.resendTimer > 0) {
                setTimeout(() => {
                    this.resendTimer -= 1
                    this.startResendTimer()
                }, 1000)
            } else {
                this.isSendCodeButtonDisabled = false;
            }
        },
    },
    computed: {
        isEmailMethod() {
            return this.method === DeclarationApprovalMethod.EMAIL;
        },
        isPhoneMethod() {
            return this.method === DeclarationApprovalMethod.PHONE;
        },
        defaultCountryCode() {
            const state = this.$store.getters.organization.state;
            return state && state.countryCode ? state.countryCode.toUpperCase() : null;
        },
        phoneNumberTranslations() {
            return {
                countrySelectorLabel: this.$t('Component(VuePhoneNumberInput):country-selector-label'),
                countrySelectorError: this.$t('Component(VuePhoneNumberInput):country-selector-error'),
                phoneNumberLabel: this.$t('Component(VuePhoneNumberInput):phone-number-label'),
                // example: this.$t('Component(VuePhoneNumberInput):phone-example')
            };
        }
    }
}
</script>
<style lang="scss">
.phone-label label {
    margin-bottom: 0.1rem;
}
</style>
